import React, { useState } from 'react';
import { Checkbox } from './ui/checkbox';
import { companyLogos } from '../data/mock';
import { useLanguage } from '../contexts/LanguageContext';

const HeroSection = () => {
  const [inputValue, setInputValue] = useState('');
  const [guidedFlow, setGuidedFlow] = useState(true);
  const [selectedUseCase, setSelectedUseCase] = useState(null);
  const { t } = useLanguage();

  // Get translated use cases
  const useCases = t('hero.useCases') || ['Lead Generation', 'Appointments', 'Support', 'Negotiation', 'Collections'];

  const handleUseCaseClick = (useCase) => {
    setSelectedUseCase(useCase);
    setInputValue(`Create a ${useCase.toLowerCase()} voice AI assistant`);
  };

  return (
    <section className="bg-[#0a0a0b] py-16 lg:py-24">
      <div className="max-w-4xl mx-auto px-6 text-center">
        {/* Main Heading */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-semibold text-white mb-4">
          {t('hero.title')} <span className="italic font-normal">{t('hero.free')}</span>{' '}
          <span className="text-teal-400">{t('hero.voiceAI')}</span> {t('hero.assistant')}
        </h1>
        <p className="text-gray-400 text-lg mb-10">
          {t('hero.subtitle')}
        </p>

        {/* Input Box */}
        <div className="bg-[#1a1a1f] rounded-xl p-6 border border-gray-800 max-w-3xl mx-auto">
          <textarea
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder={t('hero.placeholder')}
            className="w-full bg-transparent text-white placeholder-gray-500 resize-none outline-none text-base min-h-[100px]"
          />
          
          <div className="flex items-center justify-between mt-4">
            <div className="flex items-center gap-2">
              <Checkbox
                id="guided"
                checked={guidedFlow}
                onCheckedChange={setGuidedFlow}
                className="border-teal-400 data-[state=checked]:bg-teal-400 data-[state=checked]:border-teal-400"
              />
              <label htmlFor="guided" className="text-gray-300 text-sm cursor-pointer">
                {t('hero.guidedFlow')}
              </label>
            </div>
            
            <button className="bg-transparent border border-teal-400 text-teal-400 hover:bg-teal-400 hover:text-black px-6 py-2 rounded-lg text-sm font-medium transition-all duration-200 flex items-center gap-2">
              {t('hero.createAgent')}
              <span>→</span>
            </button>
          </div>
        </div>

        {/* Use Cases */}
        <div className="mt-8">
          <p className="text-gray-500 text-sm mb-4">{t('hero.chooseUseCase')}</p>
          <div className="flex flex-wrap justify-center gap-3">
            {Array.isArray(useCases) && useCases.map((useCase, index) => (
              <button
                key={index}
                onClick={() => handleUseCaseClick(useCase)}
                className={`px-4 py-2 rounded-lg text-sm transition-all duration-200 border ${
                  selectedUseCase === useCase
                    ? 'bg-teal-400/10 border-teal-400 text-teal-400'
                    : 'bg-[#1a1a1f] border-gray-700 text-gray-300 hover:border-gray-600'
                }`}
              >
                {useCase}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Trusted By Section */}
      <div className="mt-20 pt-12 border-t border-gray-800/50">
        <p className="text-center text-gray-500 text-sm mb-8">{t('home.trustedBy')}</p>
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 px-6 max-w-5xl mx-auto">
          {companyLogos.map((company, index) => (
            <div key={index} className="flex items-center justify-center opacity-70 hover:opacity-100 transition-opacity">
              <img
                src={company.logo}
                alt={company.name}
                className="h-8 md:h-10 object-contain grayscale hover:grayscale-0 transition-all duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
